"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pointingDevice = exports.touchDevice = exports.notBigScreen = exports.bigScreen = exports.notDesktop = exports.desktop = exports.tablet = exports.notMobile = exports.landscapeMobile = exports.mobile = exports.tinyMobile = void 0;
exports.tinyMobile = 'only screen and (max-width: 320px)';
exports.mobile = 'only screen and (max-width: 599px)';
exports.landscapeMobile = 'only screen and (max-width: 812px) and (orientation: landscape)';
exports.notMobile = 'only screen and (min-width: 600px)';
exports.tablet = 'only screen and (max-width: 1024.98px) and (min-width: 600px)';
exports.desktop = 'only screen and (min-width: 1025px)';
exports.notDesktop = 'only screen and (max-width: 1024.98px)';
exports.bigScreen = 'only screen and (min-width: 1440px)';
exports.notBigScreen = 'only screen and (max-width: 1439px)';
exports.touchDevice = '(hover: none)';
exports.pointingDevice = '(hover: hover)';
